<template>
  <a-select
    :placeholder="$t('common.choose')"
    style="width: 100%"
    v-model:value="localData"
    @change="onChange"
  >
    <a-select-option :value="null">
      {{ $t('common.choose') }}
    </a-select-option>
    <a-select-option v-for="(item, index) in domainList" :key="index" :value="item.domain">
      {{ item.domain }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
    emits: ['update:data', 'filterChange'],
  data() {
    return {
      localData: null,
        domainList: [],
    };
  },
  methods: {
      getDomainList() {
      this.$appAxios.post(this.$endpoints.common_get_domains).then(resp => {
        if (resp.data.status === true) {
          this.domainList = resp.data.data;
        }
      });
    },
      onChange(value) {
          this.$emit('update:data', value);
          this.$emit('filterChange');
      }
  },
  mounted() {
      this.getDomainList();
  }
};
</script>
